import { Injectable } from '@angular/core';
import {
  CustomerRebateService,
  selectRebateTakeoutOptions,
} from '@usf/ngrx-product';
import { CustomerRebate } from '@usf/product-types';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { filter, take, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomerRebatesService {
  constructor(
    private customerRebateService: CustomerRebateService,
    private store: Store<any>,
  ) {}

  getTakeoutOptions(): Observable<number[]> {
    return this.store
      .select(selectRebateTakeoutOptions)
      .pipe(map(products => products || []));
  }

  getIncentivePrograms(): Observable<CustomerRebate[]> {
    return this.customerRebateService.getCustomerRebates().pipe(
      filter(programs => !!programs),
      take(1),
    );
  }
}
